<template>
  <v-row class="white--text" justify="center" align-content="center">
    <v-col cols="7" md="6" class="pb-0 pr-0">
      <v-col class="title text-center pb-0 pt-0" cols="12">
        感染者
      </v-col>
      <v-row align="center">
        <v-col cols="5">
          <v-row justify="center" align-content="center">
            <v-col class="body-1 text-center pt-0 pb-0 pr-0" cols="12">
              7日間
            </v-col>
            <v-col class="display-1 text-center font-weight-bold pt-0 pb-0 pr-0 hidden-sm-and-down" cols="12">
              <p class="red--text">{{infection7days}}</p>
            </v-col>
            <v-col class="display-1 text-center font-weight-bold pt-0 pb-0 pr-0 hidden-md-and-up" cols="12">
              <p class="red--text">{{infection7days}}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="title" cols="3">
          <v-row justify="center" align-content="center">
            <v-col class="body-2 text-left pt-0 pb-0 pr-0" cols="12">
              1日
            </v-col>
            <v-col class="text-h6 text-left pt-0 pb-0 pr-0 hidden-sm-and-down" cols="12">
              {{infection1day}}
            </v-col>
            <v-col class="body-1 text-left pt-0 pb-0 pr-0 hidden-md-and-up" cols="12">
              {{infection1day}}
            </v-col>
          </v-row>
        </v-col>
        <v-col class="title" cols="4">
          <v-row justify="center" align-content="center">
            <v-col class="body-2 text-left pt-0 pb-0 pr-0" cols="12">
              累計
            </v-col>
            <v-col class="text-h6 text-left text-left pt-0 pb-0 pr-0 hidden-sm-and-down" cols="12">
              {{infectionTotal}}
            </v-col>
            <v-col class="body-1 text-left pt-0 pb-0 pr-0 hidden-md-and-up" cols="12">
              {{infectionTotal}}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
 
    <v-col cols="2"  md="3" class="pt-0 pb-0 pr-0">
      <v-row align="center">
        <v-col class="title text-center" cols="12">
          重症
        </v-col>
        <v-col class="display-2 text-center font-weight-bold mt-2 hidden-sm-and-down" cols="12" align-self="end">
          {{severe}}
        </v-col>
        <v-col class="display-1 text-center font-weight-bold mt-2 hidden-md-and-up" cols="12" align-self="end">
          {{severe}}
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="3" class="pt-0 pb-0 pl-0">
      <v-row align="center">
        <v-col class="title text-center" cols="12">
          死亡
        </v-col>
        <v-col class="display-2 text-center font-weight-bold mt-2 hidden-sm-and-down" cols="12" align-self="end">
          <p class="red--text">{{dead}}</p>
        </v-col>
        <v-col class="display-1 text-center font-weight-bold mt-2 hidden-md-and-up" cols="12" align-self="end">
          <p class="red--text">{{dead}}</p>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="4" class="pt-0 pl-6">
      <v-row align="center" justify="center">
        <v-col class="body-1 text-center p-0" cols="12">
          県警戒レベル
        </v-col>
        <v-col class ="p-0" cols="9">
          <img :src="getImgUrl(alertLevel)"/>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="8" class="pt-0">
      <v-row align="center">

        <v-col cols="3" class="p-0 pr-6">
          <v-row align="center">
            <v-col class="body-1 text-center p-0" cols="12">
              中等症
            </v-col>
            <v-col class="body-1 text-center font-weight-bold p-0" cols="12" align-self="end">
              {{moderate}}
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3" class="p-0 pr-6">
          <v-row align="center">
            <v-col class="body-1 text-center p-0" cols="12">
              入院
            </v-col>
            <v-col class="body-1 text-center font-weight-bold p-0" cols="12" align-self="end">
              {{hospitalize}}
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3" class="p-0 pr-6">
          <v-row align="center">
            <v-col class="body-1 text-center p-0" cols="12">
              療養
            </v-col>
            <v-col class="body-1 text-center font-weight-bold p-0" cols="12" align-self="end">
              {{recuperation}}
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3" class="p-0 pr-6">
          <v-row align="center">
            <v-col class="body-1 text-center p-0" cols="12">
              調整中
            </v-col>
            <v-col class="body-1 text-center font-weight-bold p-0" cols="12" align-self="end">
              {{waiting}}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pl-10 pr-10">
      <WeeklyPatientsChart
       :patients=patient7daysList
       :baseday=patient7dayslastUpdate>
      </WeeklyPatientsChart>
    </v-col>

    <v-col cols="12" >
      <alertList v-if="alertInfoData.alert_OKINAWA.items.length > 0" :backgroundColor=alertBackgroundColor :alertInfo=alertInfoData.alert_OKINAWA></alertList>
    </v-col>

    <v-col cols="12" class="caption text-right pb-1 pr-6">
      {{lastUpdate}} 報道値
    </v-col>
  </v-row>
</template>

<script>
import WeeklyPatientsChart from './WeeklyPatientsChart.vue'
import AlertList from './AlertList.vue'
import AlertInfo from '../statics/data/alert-info.json'

export default {
  name: 'dashboard',
  props: {
    backgroundColor: { type: [String], default: 'gray' },
    alertBackgroundColor: { type: [String], default: '#1F1E30' },
    infection1day: { type: [Number], default: 0 },
    infection7days: { type: [Number], default: 0 },
    infectionTotal: { type: [Number], default: 0 },
    hospitalize: { type: [Number], default: 0 },
    moderate: { type: [Number], default: 0 },
    severe: { type: [Number], default: 0 },
    dead: { type: [Number], default: 0 },
    alertLevel: { type: [Number], default: 0 },
    recuperation: { type: [Number], default: 0 },
    waiting: { type: [Number], default: 0 },
    lastUpdate: { type: [String], default: '' },
    patient7dayslastUpdate: { type: [String], default: '' },
    patient7daysList: {type: [Array], default: null },
  },
  data: () => ({
    alertInfoData: AlertInfo,
  }),
  computed: {
  },
  components: {
    WeeklyPatientsChart,
    AlertList,
  },
  mounted: function () {
  },
  methods: {
    getImgUrl: function(level) {
      let name = ''
      switch(level){
        case 0:   name = 'alert0_v2'; break
        case 1:   name = 'alert1_v2'; break
        case 2:   name = 'alert2_v2'; break
        case 3:   name = 'alert3a_v2'; break
        case 4:   name = 'alert3b_v2'; break
        case 5:   name = 'alert4_v2'; break
        default:  name = 'alert0_v2'; break
      }
      let images = require.context('../assets/', false, /\.svg$/)
      return images('./' + name + ".svg")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.virus-bg {
  background-image: url("~@/assets/virus.svg");
}

.bed-bg {
  background-image: url("~@/assets/bed.svg");
}

.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}
</style>
